import React, { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const BreadcrumbNavigation = () => {
  const [searchParams] = useSearchParams();
  const [currentLanguage, setCurrentLanguage] = useState('en');
  const practiceArea = searchParams.get('area') || 'corporate-law';

  useEffect(() => {
    const savedLanguage = localStorage.getItem('language') || 'en';
    setCurrentLanguage(savedLanguage);
  }, []);

  const practiceAreaNames = {
    'corporate-law': {
      en: 'Corporate Law',
      sw: 'Sheria ya Makampuni'
    },
    'family-law': {
      en: 'Family Law',
      sw: 'Sheria ya Familia'
    },
    'property-law': {
      en: 'Property Law',
      sw: 'Sheria ya Mali'
    },
    'criminal-defense': {
      en: 'Criminal Defense',
      sw: 'Utetezi wa Jinai'
    }
  };

  const breadcrumbItems = [
    {
      label: currentLanguage === 'en' ? 'Home' : 'Nyumbani',
      path: '/homepage'
    },
    {
      label: currentLanguage === 'en' ? 'Practice Areas' : 'Maeneo ya Utendaji',
      path: '/practice-areas-overview'
    },
    {
      label: practiceAreaNames[practiceArea]?.[currentLanguage] || practiceAreaNames['corporate-law'][currentLanguage],
      path: null
    }
  ];

  return (
    <nav className="bg-background border-b border-border-light py-4">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center space-x-2 text-sm">
          {breadcrumbItems.map((item, index) => (
            <React.Fragment key={index}>
              {index > 0 && (
                <Icon name="ChevronRight" size={16} className="text-text-secondary" />
              )}
              
              {item.path ? (
                <Link
                  to={item.path}
                  className="text-text-secondary hover:text-primary transition-colors duration-200 font-medium"
                >
                  {item.label}
                </Link>
              ) : (
                <span className="text-text-primary font-medium">
                  {item.label}
                </span>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default BreadcrumbNavigation;